(function() {
    'use strict';
    angular
        .module('emarket.auth')
        .controller('ForgotController', ['$state', '$mdToast', '$location', '$mdDialog', 'Auth', function ($state, $mdToast, $location, $mdDialog, Auth) {
            var vm = this;
            vm.sendForgotPassword = function () {
                Auth
                    .sendForgotPassword(vm.email)
                    .then(function (res) {
                        var alert;
                        if (res.status === 202) {
                            alert = $mdDialog
                                .alert()
                                .title('Envio de nueva contraseña')
                                .htmlContent('Se ha enviado un mensaje a tu cuenta de correo con las instrucciones para cambiar la contraseña. <br><br>En caso de no ver el mensaje en tu correo, revisa tu carpeta de correo no deseado o SPAM')
                                .ariaLabel('Alerta de envio de nueva contraseña')
                                .ok('Entendido');

                            $mdDialog
                                .show(alert)
                                .then(function() {
                                    $state.go('auth');
                                });
                        } else {
                            alert = $mdDialog
                                .alert()
                                .title('Nombre de usuario ó correo electrónico no encontrado')
                                .htmlContent('El nombre de usuario ó correo electrónico especificado no pertenece a ninguna cuenta registrada en nuestros sistemas. <br><br>Por favor confirme su nombre de usuario ó correo electrónico e intente nuevamente.')
                                .ariaLabel('Alerta de nombre de usuario ó correo electrónico no encontrado')
                                .ok('Entendido');

                            $mdDialog
                                .show(alert);
                        }
                    });
            };
            vm.escape = function (str) {
                return str ? str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') : '';
            };

            vm.validate = function () {
                var token = $location.search().token;
                Auth.validateToken(token, 'forgot', {
                    password: vm.password
                })
                    .then(function() {
                        $mdToast.show($mdToast
                            .simple()
                            .textContent('Ya puedes iniciar sesion con tu nueva contraseña')
                            .position('bottom right')
                            .hideDelay(8000));
                        $state.go('auth');
                    })
                    .catch(function(err) {
                        $mdToast.show($mdToast
                            .simple()
                            .textContent(err.$response.data.message)
                            .position('bottom right')
                            .hideDelay(8000));
                    });
            };
        }]);
}());
